var staticMapping = {
  "line1": "billing_addr1",
  "line2": "billing_addr2",
  "city": "billing_city",
  "state": "billing_state",
  "state_code": "billing_state_code",
  "country": "billing_country",
  "zip": "billing_zip",
}
export default class CopyAddressCard {
  constructor(type) {
    this.type = type;
  }

  copy(state) {
    if(this.type == "billing") {
      return this._copyBilling(state);
    }
    else {
      return this._copyShipping(state);
    }
  }

  _copyShipping(state) {
    var shippingAddress = state.order.shipping_address;
    return Object.keys(staticMapping).reduce((o, k) => {
      o[staticMapping[k]] = shippingAddress[k];
      return o;
    }, {})
  }

  _copyBilling(state) {
    var billingAddress = state.customer.billing_address;
    return Object.keys(staticMapping).reduce((o, k) => {
      o[staticMapping[k]] = billingAddress[k];
      return o;
    }, {})
  }
}